import { useQuery } from "@tanstack/react-query";
import { queryClient } from "shared/api/queryClient";
import { getBrandLanguages } from "../api/getBrandLanguages";
import { BrandLanguage } from "../type";

const QUERY_KEY = "brandLanguages";

export const useBrandLanguagesQuery = (brandId?: string) => {
  return useQuery({
    queryKey: [QUERY_KEY, brandId],
    queryFn: () => {
      if (!brandId) {
        console.error("BrandId is not provided");
        return [];
      }

      return getBrandLanguages(brandId);
    },
  });
};

export const invalidateBrandLanguagesQuery = (brandId: string) => {
  return queryClient.invalidateQueries({
    queryKey: [QUERY_KEY, brandId],
  });
};

export const getBrandLanguagesQueryData = (brandId: string) => {
  return queryClient.getQueryData<BrandLanguage[]>([QUERY_KEY, brandId]);
};

export const setBrandLanguagesQueryData = (
  brandId: string,
  data: BrandLanguage[],
) => {
  return queryClient.setQueryData([QUERY_KEY, brandId], data);
};
